import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {GithubRepository} from '@/model/resource/GithubRepository'

@HttpExclude()
export class GithubRepositoryCollection extends ExpansibleCollection<
  GithubRepository
> {
  resource?: IGithubRepositoryCollectionResourcesHolder

  @RequestExpose() idOrganizationFk: number | null = null
  @RequestExpose() idGithubRepositoryFk: number | null = null

  constructor() {
    super(GithubRepository)
  }

  queryAsPage() {
    return this.listGithubRepository()
  }

  async listGithubRepository() {
    return await Request.get(`/client/github-repository`, {params: this.params})
      .name('listGithubRepository')
      .as(this)
      .getResponse()
  }

  async sumStarsByOrganization(): Promise<number> {
    return await Request.get(
      `/client/github-repository/sum-stars-by-organization`,
      {
        params: this.params,
      }
    )
      .name('sumGithubRepositoryStarsByOrganization')
      .asNumber()
      .getData()
  }

  async countByOrganization(): Promise<number> {
    return await Request.get(
      `/client/github-repository/count-by-organization`,
      {
        params: this.params,
      }
    )
      .name('countGithubRepositoryByOrganization')
      .asNumber()
      .getData()
  }
}

export interface IGithubRepositoryCollectionResourcesHolder {}
